export const createLogger = (prefix: string) =>
    (...args: any[]) => console.log(`[${prefix}]`, ...args);
